import * as React from 'react';
import { Flex } from './Responsive';

export interface IRow {
    alignItems?: string;
    className?: string;
    flexWrap?: string;
    children: React.ReactNode;
}

const Row = (props: IRow) => {
    const { alignItems, className, flexWrap = 'wrap', children } = props;

    return (
        <Flex align={alignItems} flexWrap={flexWrap} className={className}>
            {children}
        </Flex>
    );
};

export { Row };
